import { render } from "./ProgTitleEdit.vue?vue&type=template&id=58a6f834"
import script from "./ProgTitleEdit.vue?vue&type=script&lang=js"
export * from "./ProgTitleEdit.vue?vue&type=script&lang=js"

import "./ProgTitleEdit.vue?vue&type=style&index=0&id=58a6f834&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__